<template>
  <div>
    <div v-if="config" class="row">
      <div class="col-md-3">
        <div class="form-group">
          <input type="checkbox" id="showAuthor" v-model="showConfig.showAuthor">
          <label for="showAuthor">Show Author</label>
        </div>
      </div>
      <div class="col-md-3">
        <input type="checkbox" id="showCategories" v-model="showConfig.showCategories">
        <label for="">Show Categories</label>
      </div>
      <div class="col-md-3">
        <input type="checkbox" id="showThumbnail" v-model="showConfig.showThumbnail">
        <label for="">Show Thumbnail</label>
      </div>
      <div class="col-md-3">
        <input type="checkbox" id="showDate" v-model="showConfig.showDate">
        <label for="">Show Date</label>
      </div>
      <div class="col-md-3">
        <input type="checkbox" id="showContent" v-model="showConfig.showContent">
        <label for="">Show Content</label>
      </div>
      <div class="col-md-3">
        <input type="checkbox" id="showButton" v-model="showConfig.showButton">
        <label for="">Show Button</label>
      </div>
      <div class="col-12">
        <h3>Filters</h3>
      </div>
      <div class="col-md-4">
        <div class="form-group">
          <label for="">Category</label>
          <select v-model="filters.category" class="form-control">
            <option value="all">All</option>
            <option v-for="category in categories" :key="category.cryptID" :value="category.cryptID">{{ category.name }}</option>
          </select>
        </div>
      </div>
      <div class="col-md-4">
        <div class="form-group">
          <label for="">Author</label>
          <select v-model="filters.author"  class="form-control">
            <option value="all">All</option>
            <option v-for="author in authors" :key="author.cryptID" :value="author.cryptID">{{ author.name }}</option>
          </select>
        </div>
      </div>
      <div class="col-md-4">
        <div class="form-group">
          <label for="">Type</label>
          <select v-model="filters.featured"  class="form-control">
            <option :value="false">All</option>
            <option :value="true">Featured</option>
          </select>
        </div>
      </div>

      <div class="col-12">
        <h3>Order</h3>
      </div>
      <div class="col-md-4">
        <div class="form-group">
          <label for="">Order</label>
          <select v-model="filters.mostAccessed"  class="form-control">
            <option :value="false">Date</option>
            <option :value="true">Views</option>
          </select>
        </div>
      </div>
      <div class="col-md-4">
        <div class="form-group">
          <button class="btn btn-primary" @click="getData()">reload</button>
        </div>
      </div>
      <div class="col-md-12">
        <div class="float-right">
          <button class="btn btn-success float-right" @click="save">Save</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getCategories, getAuthors } from '../../../../../../js/services/editor/blog.js';
import _ from 'lodash';

export default {
  props: ['config'],
  name: 'FeaturedGroupSettings',
  data() {
    return {
      categories: [],
      authors: [],
      filters: {
        category: 'all',
        author: 'all',
        featured: false,
        mostAccessed: false,
        amount: 3
      },
      showConfig: {
        showAuthor: true,
        showCategories: true,
        showThumbnail: true,
        showDate: true,
        showContent: true,
        showButton: true
      }
    };
  },
  methods: {
    getData() {
      let vm = this;
      getCategories()
        .then(({data}) => {
          (data.success) ? vm.categories = data.data : console.log('error categories');
        });

      getAuthors()
        .then(({data}) => {
          (data.success) ? vm.authors = data.data : console.log('error authors');
        });
    },
    sayHello(value) {
      console.log('hello');
      console.log(value);
      console.log('hello');
    },
    save() {
      let obj = { filters: this.filters, showConfig: this.showConfig };
      this.$emit('save', obj);
      this.$emit('close');
    }
  },
  watch: {
    config() {
      this.getData();
      typeof this.config.filters !== 'undefined' ? this.filters = _.clone(this.config.filters) : console.log('nao tem');
      typeof this.config.showConfig !== 'undefined' ? this.showConfig = _.clone(this.config.showConfig) : console.log('nao tem');
    }
  }
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/editor/apps/Blog/Settings/content/FeaturedGroupSettings.vue